<ng-container *ngIf="resultSearch?.length">
  <div class="title_columns"
    [style.grid-template-columns]="tabsSearchActive === 'Invoice' ? '20% repeat(3, 1fr) 5%': 'repeat(2, 15%) repeat(3, 1fr) 5%'">
    <span *ngFor="let c of getColumn()"> {{getTitleColumns(c)}}</span>
    <span></span>
  </div>

  <ngx-simplebar>
    <div class="result_line" *ngFor="let rl of resultFiltered"
      [style.grid-template-columns]="tabsSearchActive === 'Invoice' ? '20% repeat(3, 1fr) 5%': 'repeat(2, 15%) repeat(3, 1fr) 5%'">
      <span>
        <fa-icon [icon]="getFaIcon('faFilePdf')" (click)="exportPdfBill(rl)" [matTooltip]="getTooltip('downloadBill')"
          appChangeColorTheme attribute="color"></fa-icon>
        {{rl.bookingReference}}
      </span>
      <span *ngIf="tabsSearchActive === 'OfferKey'">{{rl.offerKey}}</span>
      <span>{{rl.bookingRecordDate | date: 'shortDate'}}</span>
      <span>{{rl.bookingAmount}}€</span>
      <div class="clientCell" [matTooltip]="rl?.lastName + ' ' + rl?.firstName + ' ' + rl?.email">
        {{rl.lastName}} {{rl.firstName}}
        <ng-container *ngIf="rl.email">
          <i>{{rl?.email}}</i>
        </ng-container>

      </div>
      <span appChangeColorTheme attribute="color"><fa-icon [icon]="getFaIcon('faArrowAltCircleRight')"
          (click)="goToViewCLient(rl)"></fa-icon></span>
    </div>
  </ngx-simplebar>
</ng-container>